import { render, staticRenderFns } from "./CrossSelling.vue?vue&type=template&id=5bba13e8&"
import script from "./CrossSelling.vue?vue&type=script&lang=js&"
export * from "./CrossSelling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports